import Beneficios from './Beneficios';
export default Beneficios;
